import { MediaTypeDefinitions } from 'Types/Tasks.types'
import Paragraph from 'antd/lib/typography/Paragraph'
import styles from '../Prompt.module.less'
import { AudioViewer } from 'Components/common/AudioViewer/AudioViewer'

type PromptAudioContentPropsType = {
    content: MediaTypeDefinitions
    id: string
}

export const PromptAudioContent = (props: PromptAudioContentPropsType) => {
    return (
        <div className={styles['audio-content']} id={props.id}>
            <Paragraph>{props.content.label}</Paragraph>
            <AudioViewer url={props.content.url} />
        </div>
    )
}
